import classNames from "classnames";
import { PropsWithChildren } from "react";
import styles from "./detailedAccordion.module.scss";

export function AccordionContentWrapper(
  props: PropsWithChildren<{
    bgColor?: string;
    hasPadding?: boolean;
  }>,
) {
  return (
    <div
      className={classNames(styles.accordionContent, {
        [styles["hasPadding"]]: props.hasPadding,
      })}
      style={{ backgroundColor: props.bgColor }}
    >
      {props.children}
    </div>
  );
}
